/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState} from "react";

// reactstrap components
import { Container, Row, Col, Modal, ModalBody } from "reactstrap";
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";


// core components

function SectionDark() {
    const websiteData = useRecoilValue(websiteDataState)
    const [selectedPhoto, setSelectedPhoto] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    const openModal = (photo) => {
        setSelectedPhoto(photo)
        setModalOpen(true)
    }

    const closeModal = () => {
        setModalOpen(false)
        setTimeout(() => setSelectedPhoto(null), 300)
    }

    return (
        <>
            <div className="section" style={{ 
                padding: "80px 0",
                background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)"
            }}>
                <Container fluid style={{ maxWidth: "1400px" }}>
                    <Row>
                        <Col className="ms-auto me-auto text-center" md="12">
                            <h2 className="title" style={{ 
                                fontSize: "36px", 
                                fontWeight: "700",
                                color: "#2d3748",
                                marginBottom: "48px",
                                letterSpacing: "-0.5px",
                                lineHeight: "1.2"
                            }}>Kijk Binnen</h2>
                            
                            {/* Modern CSS Grid Gallery */}
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                                gap: "24px",
                                padding: "0 20px"
                            }}>
                                {websiteData?.photos?.map((photo, index) => (
                                    <div 
                                        key={index}
                                        onClick={() => openModal(photo)}
                                        style={{
                                            position: "relative",
                                            overflow: "hidden",
                                            borderRadius: "16px",
                                            cursor: "pointer",
                                            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.08)",
                                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                            backgroundColor: "#fff"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-8px)";
                                            e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)";
                                            const overlay = e.currentTarget.querySelector('.photo-overlay');
                                            if (overlay) overlay.style.opacity = "1";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.08)";
                                            const overlay = e.currentTarget.querySelector('.photo-overlay');
                                            if (overlay) overlay.style.opacity = "0";
                                        }}
                                    >
                                        <img 
                                            src={photo?.photo?.url || ""} 
                                            alt={photo.name}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                display: "block"
                                            }}
                                        />
                                        <div 
                                            className="photo-overlay"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: "linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%)",
                                                display: "flex",
                                                alignItems: "flex-end",
                                                padding: "25px",
                                                opacity: 0,
                                                transition: "opacity 0.3s ease"
                                            }}
                                        >
                                            <div style={{ textAlign: "left", width: "100%" }}>
                                                <p style={{
                                                    color: "#FFFFFF",
                                                    fontSize: "15px",
                                                    fontWeight: "600",
                                                    margin: 0,
                                                    textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                                                    letterSpacing: "0.2px"
                                                }}>{photo?.name}</p>
                                                <p style={{
                                                    color: "rgba(255, 255, 255, 0.8)",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    margin: "5px 0 0 0",
                                                    letterSpacing: "0.2px"
                                                }}>Klik om te vergroten</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>

                {/* Modern Modal/Lightbox */}
                <Modal 
                    isOpen={modalOpen} 
                    toggle={closeModal}
                    size="xl"
                    centered
                    style={{ maxWidth: "90vw" }}
                >
                    <ModalBody 
                        style={{ 
                            padding: 0,
                            position: "relative",
                            backgroundColor: "#000",
                            borderRadius: "16px",
                            overflow: "hidden"
                        }}
                        onClick={closeModal}
                    >
                        <button
                            onClick={closeModal}
                            style={{
                                position: "absolute",
                                top: "20px",
                                right: "20px",
                                background: "rgba(255, 255, 255, 0.9)",
                                border: "none",
                                borderRadius: "50%",
                                width: "44px",
                                height: "44px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontSize: "24px",
                                fontWeight: "300",
                                color: "#2d3748",
                                zIndex: 10,
                                transition: "all 0.3s ease",
                                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.1)";
                                e.currentTarget.style.background = "#69be50";
                                e.currentTarget.style.color = "#FFFFFF";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.background = "rgba(255, 255, 255, 0.9)";
                                e.currentTarget.style.color = "#2d3748";
                            }}
                        >
                            ×
                        </button>
                        
                        {selectedPhoto && (
                            <div style={{ textAlign: "center" }}>
                                <img 
                                    src={selectedPhoto?.photo?.url || ""} 
                                    alt={selectedPhoto?.name}
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "85vh",
                                        width: "auto",
                                        height: "auto",
                                        display: "block",
                                        margin: "0 auto"
                                    }}
                                />
                                <div style={{
                                    background: "linear-gradient(to top, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.7) 100%)",
                                    padding: "30px",
                                    textAlign: "center"
                                }}>
                                    <p style={{
                                        color: "#FFFFFF",
                                        fontSize: "20px",
                                        fontWeight: "600",
                                        margin: 0
                                    }}>{selectedPhoto?.name}</p>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </>
    );
}

export default SectionDark;
